import * as Data from "~/Data";
import * as DriverId from "./DriverId";
import * as Driver from "~/Driver";

export * as Action from "./Action";
export * as Request from "./Request";
export * as DriverId from "./DriverId";

export const useIndividualStore = (): Data.Store.Store<Driver.Driver> =>
  Data.Store.useSelector(({ drivers: { individualStore } }) => individualStore);

export function useFromIndividualReference<A>(
  get: Data.Reference.Get.When<Driver.Driver, A>
): A {
  // Checks whether the driver has been fetched w/ either the `/drivers` or `drivers/id` endpoint
  const individual_driver = pipe(useIndividualStore(), Data.Store.Get.fromReference(get))
  const list_driver = pipe(Driver.useStore(), Data.Store.Get.fromReference(get)) 
  if((list_driver as unknown as Driver.Driver)?.name){
    return list_driver;
  }
  return individual_driver
}

export namespace State {
  export type State = {
    readonly driverId: DriverId.DriverId;
    readonly individualStore: Data.Store.Store<Driver.Driver>;
  };

  export const initial = (): State => ({
    individualStore: Data.Store.initial(),
    driverId: DriverId.State.initial(),
  });
}
